import { Text } from "@cvp/design-system/react";
import styled from "styled-components";

export default styled(Text)`
  color: #e83131;
  font-size: 1em;
`;
